(function () {
  if (window.GLHCartHotfix === 'v7-light-cart-ui') return;
  window.GLHCartHotfix = 'v7-light-cart-ui';

  const STYLE_ID = 'glh-cart-hotfix-style';

  function injectCartStyle() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.glh-cart-aov__warning[hidden] { display: none !important; }',
      '.glh-cart-aov__card.is-invalid { border-color: rgba(180, 35, 24, .34) !important; background: #fff7f5 !important; box-shadow: 0 10px 30px rgba(180, 35, 24, .10) !important; }',
      '.glh-cart-aov__card.is-invalid .glh-cart-aov__title { color: #b42318 !important; }',
      '.glh-cart-aov__card.is-invalid .glh-cart-aov__text { color: #7a271a !important; font-weight: 800 !important; }',
      '.glh-cart-aov__card.is-invalid .glh-cart-aov__button { background: #b42318 !important; box-shadow: 0 10px 24px rgba(180, 35, 24, .18) !important; }',
      '.glh-cart-aov.is-busy { opacity: .72 !important; pointer-events: none !important; }',
      'html.glh-cart-converting-discount .glh-cart-aov { opacity: .72 !important; pointer-events: none !important; }',
      'html.glh-cart-converting-discount .glh-cart-aov__button { cursor: wait !important; }',
      '.cart-personalizer-qty-note, [data-glh-personalized-qty-note] { display: none !important; }'
    ].join('\n');

    document.head.appendChild(style);
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase().replace(':', '');
  }

  function hideVisibleQtyProperties() {
    document.querySelectorAll('.cart-item__details .product-option').forEach(function (row) {
      const label = row.querySelector('dt');
      if (!label) return;

      const key = normalize(label.textContent);
      if (key === 'qty' || key === 'quantity') {
        row.hidden = true;
        row.setAttribute('data-glh-hidden-cart-qty', '');
      }
    });
  }

  function removeInjectedQtyNotes() {
    document.querySelectorAll('.cart-personalizer-qty-note, [data-glh-personalized-qty-note]').forEach(function (note) {
      note.remove();
    });
  }

  function normalizeQuantityHeader() {
    document.querySelectorAll('.cart-items thead th.cart-items__heading--wide').forEach(function (heading) {
      heading.setAttribute('aria-label', 'Remove');
      heading.innerHTML = '<span class="visually-hidden">Remove</span>';
    });
  }

  function restoreRemoveButtons() {
    document.querySelectorAll('cart-remove-button a').forEach(function (link) {
      link.removeAttribute('hidden');
      link.setAttribute('title', 'Remove');

      if (!link.querySelector('.glh-cart-remove-text')) {
        const label = document.createElement('span');
        label.className = 'visually-hidden glh-cart-remove-text';
        label.textContent = 'Remove';
        link.appendChild(label);
      }
    });
  }

  function cleanupCartUi() {
    injectCartStyle();
    normalizeQuantityHeader();
    hideVisibleQtyProperties();
    removeInjectedQtyNotes();
    restoreRemoveButtons();
  }

  function scheduleCleanup() {
    window.setTimeout(cleanupCartUi, 0);
    window.setTimeout(cleanupCartUi, 350);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleCleanup);
  } else {
    scheduleCleanup();
  }

  document.addEventListener('cart:updated', scheduleCleanup);
  document.addEventListener('cart:update', scheduleCleanup);
  document.addEventListener('shopify:section:load', scheduleCleanup);
})();
